export enum Status {
  Fail = 'fail',
  Info = 'info',
  Neutral = 'neutral',
  Pending = 'pending',
  Success = 'success',
  Warning = 'warning',
}
